(function () {
	const slideshow = () => {
		$(".slideshow-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".slideshow");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const speed = box.data("speed") * 1000;
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
						waitForTransition: true,
					},
				};
			} else {
				autoplayParm = {};
			}
			let swiperParms = {
				parallax: box.data("parallax"),
				effect: box.data("effect"),
				speed: speed,
				loop: false,
				centeredSlides: false,
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				creativeEffect: {
					prev: {
						shadow: false,
						translate: [0, 0, -400],
					},
					next: {
						translate: ["100%", 0, 0],
					},
				},
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: false,
				},
				flipEffect: {
					slideShadows: false,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: "true",
					type: "bullets",
				renderBullet: function (activeIndex, className) {
					return (
						'<span class="' +
						className +
						'">' +
						'<svg class="bullet-progress" viewBox="0 0 36 36">' +
						'<circle class="bullet-progress__fill" cx="18" cy="18" r="15" />' +
						"</svg>" +
						"</span>"
					);
				},
				},
				...autoplayParm,
			};
			const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);

			/* Slide click-to-navigate: uses JS to avoid Swiper/z-index conflicts */
			let pointerStartX = 0;
			let pointerStartY = 0;
			let pointerMoved = false;
			const MOVE_THRESHOLD = 10;

			const clickableSlides = box[0].querySelectorAll('.slideshow-slide--has-link');
			clickableSlides.forEach(function (slide) {
				slide.addEventListener('pointerdown', function (e) {
					pointerMoved = false;
					pointerStartX = e.clientX;
					pointerStartY = e.clientY;
				});
				slide.addEventListener('pointermove', function (e) {
					var dx = Math.abs(e.clientX - pointerStartX);
					var dy = Math.abs(e.clientY - pointerStartY);
					if (dx > MOVE_THRESHOLD || dy > MOVE_THRESHOLD) {
						pointerMoved = true;
					}
				});
				slide.addEventListener('click', function (e) {
					/* If user was swiping, do nothing */
					if (pointerMoved) return;
					/* If user clicked on a button/link inside the slide, let it handle itself */
					if (e.target.closest('a, button, .slideshow-slide__button')) return;

					var href = slide.getAttribute('data-slide-link');
					var newTab = slide.getAttribute('data-slide-new-tab') === 'true';
					if (!href) return;

					if (newTab) {
						window.open(href, '_blank', 'noopener,noreferrer');
					} else {
						window.location.href = href;
					}
				});
			});

			swiper.on("slideChange", function () {
				box.css("--bullet-duration", `${delay + speed}ms`);
			});
			swiper.on("beforeTransitionStart", function () {
				colorScheme(this);
			});
			swiper.on("slideChange", function () {
				colorScheme(this);
			});

			function colorScheme(context) {
				//const parent = $(context.el).parent();
				const parent = box.find(".slideshow-bottom");
				const activeIndex = context.activeIndex;
				const activeSlide = context.slides[activeIndex];
				const changeItems = [parent[0]];
				const colorScheme = $(activeSlide)
					.find(".slideshow-slide")
					.data("color-scheme");
				changeItems.forEach((item) => {
					if(!item) return '';
					const classes = item.classList;
					for (let className of classes) {
						if (/color-background-\d+$/.test(className)) {
							item.classList.remove(className);
						}
					}
					item.classList.add(colorScheme);
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		slideshow();
		document.addEventListener("shopify:section:load", function () {
			slideshow();
		});
	});
})();
